module.exports = __webpack_public_path__ + "static/media/pexels-field-engineer-442150.27b5997d.jpg";